exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".About{position:absolute;left:0;top:0;width:100%;pointer-events:none;z-index:100;color:#000;background-color:#fff;z-index:999;display:none}.About--open{display:block}.About__close span{background-color:#000}.About__inner{width:100%;margin:0 auto;color:#000;padding-bottom:40px;max-width:1000px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/components/About/About.scss
// module id = 279
// module chunks = 0